import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { RenderContextComponent } from '../../../../models/base/render-context-component';
import { ResizeObserver } from '@juggle/resize-observer';
import { exists } from '../../../../functions/exists';
import { PrintCardJigViewModel } from './print-card-jig-view-model';
import type { CardData } from '../../../../models/print-cards/card-data';
import type { ShelfTalkerCardData } from '../../../../models/shelf-talkers/shelf-talker-card-data';

@Component({
  selector: 'app-card-jig',
  templateUrl: './card-jig.component.html',
  styleUrls: ['./card-jig.component.scss'],
  providers: [PrintCardJigViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CardJigComponent extends RenderContextComponent {
  constructor(
    public viewModel: PrintCardJigViewModel,
    protected elementRef: ElementRef
  ) {
    super();
  }

  @Input() preview = false;
  @Input() data: CardData | ShelfTalkerCardData;

  private resizeObserver: ResizeObserver;

  setupViews() {}

  setupBindings() {
    this.observeContainer();
  }

  private observeContainer() {
    this.resizeObserver?.disconnect();
    if (exists(this.elementRef?.nativeElement)) {
      this.resizeObserver = new ResizeObserver(_ => {
        this.viewModel.connectToHeight(this.elementRef.nativeElement?.clientHeight ?? 0);
        this.viewModel.connectToWidth(this.elementRef.nativeElement?.clientWidth ?? 0);
      });
      this.resizeObserver.observe(this.elementRef.nativeElement);
    }
  }

  destroy() {
    super.destroy();
    this.resizeObserver?.disconnect();
  }
}
